import React from 'react';

/**
 * Compact card action that opens the shared full-detail surface
 * (`ProviderItemDetail`) for an item. Mirrors `ViewContextButton` styling so
 * both actions read as siblings in the card's action row.
 */
export const ViewDetailButton: React.FC<{
  onClick: (e: React.MouseEvent) => void;
  label?: string;
}> = ({ onClick, label = 'Ver detalle' }) => (
  <button
    type="button"
    data-testid="view-detail-button"
    onClick={onClick}
    title="Ver el detalle completo de este ítem"
    aria-label={label}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      height: 28,
      padding: '0 10px',
      borderRadius: 9,
      border: '1px solid var(--z-border)',
      background: 'var(--z-surface)',
      color: 'var(--z-muted-2)',
      fontSize: 11.5,
      fontWeight: 600,
      cursor: 'pointer',
    }}
  >
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 3v18M15 3v18" />
    </svg>
    {label}
  </button>
);
